import { axios_instance } from "@/api/api";
import { useQueryClient } from "@tanstack/vue-query";
import type { AxiosProgressEvent } from "axios";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { toast } from "vue3-toastify";

export const use_create_version = defineStore("create_version", () => {
  const version = ref("");
  const description = ref("");
  const is_confirm_disabled = computed(() => {
    return version.value.trim() === "";
  });
  const loading = ref(false);
  const progress = ref(0);
  const queryClient = useQueryClient();

  const upload_version = async (
    f: File | undefined,
    version: string | undefined,
    description: string | undefined,
    type: string | undefined,
  ) => {
    if (!f) {
      toast.error("Thiếu file để tải lên");
      return;
    }

    if (!version) {
      toast.error("Thiếu phiên bản");
      return;
    }

    if (!type) {
      toast.error("Thiếu loại phiên bản");
      return;
    }

    loading.value = true;
    progress.value = 0;
    const data = new FormData();
    data.append("type", type);
    data.append("version", version);
    if (description) data.append("description", description);
    data.append("file", f);

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "/api/v1/view/version/",
      data: data,
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        const total = progressEvent.total;
        if (total) {
          progress.value = Math.round((progressEvent.loaded * 100) / total);
        }
      },
    };

    return axios_instance
      .request(config)
      .then(() => {
        toast.success("Tải lên thành công");
        // Invalidate the versions query to refetch the list
        queryClient.invalidateQueries({ queryKey: ["versions"] });
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        loading.value = false;
        progress.value = 0;
      });
  };

  return {
    version,
    description,
    is_confirm_disabled,
    loading,
    progress,
    upload_version,
  };
});
